import { render, staticRenderFns } from "./SafeplanList.vue?vue&type=template&id=24e02bb2&scoped=true&"
import script from "./SafeplanList.vue?vue&type=script&lang=js&"
export * from "./SafeplanList.vue?vue&type=script&lang=js&"
import style0 from "./SafeplanList.vue?vue&type=style&index=0&id=24e02bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e02bb2",
  null
  
)

export default component.exports